export function updateUserRequest(data) {
  return {
    type: '@user/UPDATE_USER_REQUEST',
    payload: { data },
  };
}

export function updateUserSuccess(user) {
  return {
    type: '@user/UPDATE_USER_SUCCESS',
    payload: { user },
  };
}

export function failure() {
  return {
    type: '@user/FAILURE',
  };
}

export function ChatAutenticado() {
  return {
    type: '@user/CHAT_AUTENTICADO',
  };
}

export function ChatDeslogar() {
  return {
    type: '@user/CHAT_DESLOGAR',
  };
}
